import { LIST_ASSETS, LIST_USERS, UPDATE_ADOPTION } from './bridge-methods';

const SEPARATOR = '::';

export function getBaseMethod(method) {
  const parts = method.split(SEPARATOR);
  if (parts.length === 2) {
    return parts[1];
  }
  return method;
}

function getNewKey(baseMethod, newMethod) {
  return `watson.bridge.${newMethod}${SEPARATOR}${baseMethod}`;
}

export const LIST_ALL_USERS = getNewKey(LIST_USERS, 'LIST_ALL_USERS');

export const LIST_ADOPTION_USERS = getNewKey(LIST_USERS, 'LIST_ADOPTION_USERS');

export const UPDATE_ADOPTION_USERS = getNewKey(
  UPDATE_ADOPTION,
  'UPDATE_ADOPTION_USERS'
);

export const UPDATE_ADOPTION_ALL_USERS = getNewKey(
  UPDATE_ADOPTION,
  'UPDATE_ADOPTION_ALL_USERS'
);

export const LIST_ALL_ASSETS = getNewKey(LIST_ASSETS, 'LIST_ALL_ASSETS');

export const SEARCH_ASSETS = getNewKey(LIST_ASSETS, 'SEARCH_ASSETS');

export const LIST_ACTIVE_ASSETS = getNewKey(LIST_ASSETS, 'LIST_ACTIVE_ASSETS');

export const LIST_ADOPTION_ASSETS = getNewKey(
  LIST_ASSETS,
  'LIST_ADOPTION_ASSETS'
);

export const UPDATE_ADOPTION_ASSETS = getNewKey(
  UPDATE_ADOPTION,
  'UPDATE_ADOPTION_ASSETS'
);

export const UPDATE_ADOPTION_NAME = getNewKey(
  UPDATE_ADOPTION,
  'UPDATE_ADOPTION_NAME'
);



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/bridge-method-remap.js